module.exports = __webpack_public_path__ + "static/media/exclamationCircle.e9f7d7ef.svg";